<template>

  <div>
    <div
      v-if="currentVariant && currentVariant.pricetype=='default'"
      class="price"
    >
      {{currentVariant.pricestr}} &euro;
    </div>
     <div
      v-else-if="currentVariant && currentVariant.pricetype=='voucher'"
      class="price"
    >
      <label for="custom_price">{{trans('please enter an amount this voucher should be valid for:','Bitte geben Sie den Betrag ein, den dieser Gutschein wert sein soll')}}
      </label>
      <div class="input-group mb-3">
        <input type="number" class="form-control" id="custom_price" name="custom_price" min="50" max="10000" placeholder="min 50EUR"
        v-model="customPrice">
        <div class="input-group-append">
          <span class="input-group-text" id="basic-addon2">EUR</span>
        </div>
      </div>
    </div>
    <div
      v-else
      class="price"
    >
      <span class="price-old">{{defaultprice}} &euro; </span> &nbsp; <span class="price-discounted" v-if="currentVariant">{{currentVariant.pricestr}} &euro;</span>
    </div>
  </div>
</template>

<script>
const R = require("ramda");

export default {
  name: "VariantPrice",
  props: {
    defaultprice: { type: String },
  },
  methods: {
    trans: function (en, de) {
      return this.$store.getters.lang == "de" ? de : en;
    },
  },
  computed: {

    currentVariant: function () {
      return this.$store.getters.currentVariant;
    },
    customPrice: {
      get () {
        return this.$store.getters.customPrice;
      },
      set (value) {
        this.$store.commit('setCustomPrice', parseInt(value,10))
      }
    }

  },
};
</script>
<style lang="scss">
@import "../styles/settings.scss";
.price.price-static {
  display: none;
}
.input-group {
  max-width:14rem;
}
label {
  font-weight: normal;
  display: block;
  margin-bottom: 1rem;
  font-size: 1.2em;
}
</style>
